export enum EExceptionType {
    BIOMETRIC = 0,
    LOCATION = 1,
    MICRO_LOCATION = 2,
    NO_LOCATION_OR_MICROLOCATION = 3,
    NO_DEVICE_LOCATION = 4,
    MISSING_PUNCH = 5,
    MISSING_EMPLOYEE_APPROVAL = 6,
    MISSING_SUPERVISOR_APPROVAL = 7,
    MISSING_IN_PUNCH = 8,
    EARLY_IN_PUNCH = 9,
    LATE_IN_PUNCH = 10,
    EARLY_OUT_PUNCH = 11,
    LATE_OUT_PUNCH = 12,
    MISSING_BREAK = 13,
    LONG_BREAK = 14,
    NO_SHIFT = 15,
    QUESTION_EXCEPTION = 16,
    TIMEOFF = 17,
    DEVICE_STATUS = 18,
    SUSPENSE_PUNCH = 19,
    TIME_FRAUD = 20,
    PUNCH_NOTE = 21,
    CA_MEAL_BREAK = 22,
    MINIMUM_BREAK_OVERRIDE = 23
}